
import React from "react";
// import TermProject  from '../Components/Dashboard/Term-projects/Term-Project';
import { Suspense, lazy } from 'react';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SkeletonL from "../Components/Skeleton/Withlogin";
import Swal from 'sweetalert2'

const TermProject = lazy(() => import('../Components/Dashboard/Term-projects/Term-Project'));
const AuthTermProject = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Suspense fallback={<SkeletonL/>}>
  <TermProject/>
</Suspense> : <>
  {
     Swal.fire({
      title: "Timeout",
      text: "Your Session has been expired please relogin",
      icon: "info",
      confirmButtonText: "Ok"
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href="https://accredian.com"
      }
    })
  }
  </>
}
export default AuthTermProject;
